import '@babel/polyfill'; // använder useBuiltIns: 'usage' i babel.config.js istället

import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import store from './store';
// import './registerServiceWorker';

// SCSS globalt
import './scss/screen.scss';

// SIMPLEBAR
// https://github.com/hfalucas/vue-simplebar
// import VueSimplebar from 'vue-simplebar';
// import 'vue-simplebar/dist/vue-simplebar.css';
// Vue.use(VueSimplebar);

// export const loadedGoogleMapsAPI = new Promise((resolve, reject) => {
//   window['GoogleMapsInit'] = resolve;
//   let GMap = document.createElement('script');
//   GMap.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=AIzaSyBve46HlNTw1PSh634doV8B40a21yWem-g&callback=GoogleMapsInit&region=IN`);
//   document.body.appendChild(GMap);
// });

// VUE2-GOOGLE-MAPS
// https://www.npmjs.com/package/vue2-google-maps
// https://alligator.io/vuejs/vue-google-maps/

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBve46HlNTw1PSh634doV8B40a21yWem-g',
    libraries: 'places'
  }
});


Vue.config.productionTip = false;

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app');